import { useDispatch, useSelector } from '@redux';
import { rejectTransferOrders } from '@redux/transferOrders/actions';
import { Button, Form, Input, Modal } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';

const RejectReason = ({ onCancel }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const currentData = useSelector<DynamicObjectType>(
    (state) => state.transferOrders.currentData,
  );
  const modal = useSelector<DynamicObjectType>((state) => state.modal.modal);

  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      dispatch(
        rejectTransferOrders({
          data: {
            id: currentData?.id,
            data: values,
          },
          options: {
            isShowSuccessNoti: true,
          },
        }),
      )
        .then((res: DynamicObjectType) => {
          if (res?.payload?.success) {
            onCancel();
            setLoading(false);
            window.location.reload();
          }
        })
        .then(() => setLoading(false));
    });
  };

  return (
    <Modal
      open={modal?.reject?.isOpen}
      onCancel={onCancel}
      footer={null}
      width={443}
      closeIcon={false}
      closable={false}
      title={t('transferOrders.rejectReason')}
    >
      <div className="grid gap-5">
        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <Form.Item
            name="textRejectReason"
            label="Note your reason"
            rules={[{ required: true, message: 'Please input your reason!' }]}
          >
            <Input.TextArea />
          </Form.Item>
          <div className="flex justify-end items-center gap-2.5">
            <Button className="h-[40px] w-[100px]" onClick={onCancel}>
              {t('button.cancel')}
            </Button>
            <Button
              className="h-[40px] w-[100px]"
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              {t('button.ok')}
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default RejectReason;
